import { ColumnConfig } from '@components/design/migrated/Table';
import React from 'react';
import { OpportunityReviewTableContent } from '@models/OpportunityReview';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import OpportunityReviewTableRow from '../opportunity-review-table-row/OpportunityReviewTableRow';

interface Props {
  opportunityReviewBoardPg: OpportunityReviewTableContent;
  columns: ColumnConfig[];
  sortedColumn: string;
  selectedGrowthType: GrowthTypes;
  currencySymbol: string;
}

export const OpportunityReviewTableHead: React.FC<Props> = ({
  opportunityReviewBoardPg,
  columns,
  sortedColumn,
  selectedGrowthType,
  currencySymbol,
}) => {
  return (
    <tbody>
      <OpportunityReviewTableRow
        key={'Total'}
        opportunityReviewBoardPg={opportunityReviewBoardPg}
        columns={columns}
        isStickyRow={true}
        sortedColumn={sortedColumn}
        selectedGrowthType={selectedGrowthType}
        currencySymbol={currencySymbol}
      />
    </tbody>
  );
};

export default OpportunityReviewTableHead;
